import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
import { ClientConversationComponent } from '@frontend/shared';

/**
 * The `/c/:participantAuthKey` route. The chat itself is `shared-client-conversation`, which the
 * embed lib renders as well; this wrapper only supplies the key from the URL and decides what a
 * reload means here: reloading the page.
 */
@Component({
  selector: 'app-conversation',
  standalone: true,
  imports: [ClientConversationComponent],
  templateUrl: './conversation.component.html',
  styleUrl: './conversation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationComponent {
  readonly #activatedRoute = inject(ActivatedRoute);

  readonly participantAuthKey = toSignal(
    this.#activatedRoute.params.pipe(map((params) => params['participantAuthKey'] as string)),
    { initialValue: '' }
  );

  reload(): void {
    window.location.reload();
  }
}
